import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding-left: 6rem;
    
`;

export const Content = styled.div`{
    width: 100%;
    max-width: 80%;
    margin: 30px;
    background: #${props => props.whitelabel.grayLight};
    border-radius: 4px;
    padding: 20px;
    display:grid;
    grid-gap: 30px 20px;
}`
